<script>
export default {
  name: 'CalendarCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
      :fill="color"
    />
    <path
      d="M19 15C16.79 15 15 16.79 15 19C15 19.75 15.21 20.46 15.58 21.06C16.27 22.22 17.54 23 19 23C20.46 23 21.73 22.22 22.42 21.06C22.79 20.46 23 19.75 23 19C23 16.79 21.21 15 19 15ZM21.07 18.57L18.94 20.54C18.8 20.67 18.61 20.74 18.43 20.74C18.24 20.74 18.05 20.67 17.9 20.52L16.91 19.53C16.62 19.24 16.62 18.76 16.91 18.47C17.2 18.18 17.68 18.18 17.97 18.47L18.45 18.95L20.05 17.47C20.35 17.19 20.83 17.21 21.11 17.51C21.39 17.81 21.37 18.28 21.07 18.57Z"
      :fill="color"
    />
    <path
      d="M20 9.84009H4C3.45 9.84009 3 10.2901 3 10.8401V17.0001C3 20.0001 4.5 22.0001 8 22.0001H12.93C13.62 22.0001 14.1 21.3301 13.88 20.6801C13.68 20.1001 13.51 19.4601 13.51 19.0001C13.51 15.9701 15.98 13.5001 19.01 13.5001C19.3 13.5001 19.59 13.5201 19.87 13.5701C20.47 13.6601 21.01 13.1901 21.01 12.5901V10.8501C21 10.2901 20.55 9.84009 20 9.84009ZM9.21 18.2101C9.02 18.3901 8.76 18.5001 8.5 18.5001C8.24 18.5001 7.98 18.3901 7.79 18.2101C7.61 18.0201 7.5 17.7601 7.5 17.5001C7.5 17.2401 7.61 16.9801 7.79 16.7901C7.89 16.7001 7.99 16.6301 8.12 16.5801C8.49 16.4201 8.93 16.5101 9.21 16.7901C9.39 16.9801 9.5 17.2401 9.5 17.5001C9.5 17.7601 9.39 18.0201 9.21 18.2101ZM9.21 14.7101C9.16 14.7501 9.11 14.7901 9.06 14.8301C9 14.8701 8.94 14.9001 8.88 14.9201C8.82 14.9501 8.76 14.9701 8.7 14.9801C8.63 14.9901 8.56 15.0001 8.5 15.0001C8.24 15.0001 7.98 14.8901 7.79 14.7101C7.61 14.5201 7.5 14.2601 7.5 14.0001C7.5 13.7401 7.61 13.4801 7.79 13.2901C8.02 13.0601 8.37 12.9501 8.7 13.0201C8.76 13.0301 8.82 13.0501 8.88 13.0801C8.94 13.1001 9 13.1301 9.06 13.1701C9.11 13.2101 9.16 13.2501 9.21 13.2901C9.39 13.4801 9.5 13.7401 9.5 14.0001C9.5 14.2601 9.39 14.5201 9.21 14.7101ZM12.71 14.7101C12.52 14.8901 12.26 15.0001 12 15.0001C11.74 15.0001 11.48 14.8901 11.29 14.7101C11.11 14.5201 11 14.2601 11 14.0001C11 13.7401 11.11 13.4801 11.29 13.2901C11.67 12.9201 12.34 12.9201 12.71 13.2901C12.89 13.4801 13 13.7401 13 14.0001C13 14.2601 12.89 14.5201 12.71 14.7101Z"
      :fill="color"
    />
  </svg>
</template>
